module.exports = __webpack_public_path__ + "media/src/components/InsuranceProduct/personal-accident-insurance-327e1752b0bb911117c28d4a9d51c949.png";